import React from 'react';
import {FooterContainerStyled} from "../../../styled/Footer";
import Logo from "../Logo/Logo";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import IconButtonStyled from "../../../styled/IconButton";
import {Link} from 'react-router-dom'



const Footer = () => {
    return (
        <FooterContainerStyled>
            <div className="topHalf">
                <Logo width='5rem' height='auto' />
                <span className="newsletter">
                    <p>Newsletter</p>
                    <div className="subscribe">
                        <input type="email" name="email" id="email" placeholder="Input your email" />
                        <button>Subscribe</button>
                    </div>
                </span>
            </div>

            <div className="midHalf">

                <span className="links">
                    <div className="items office">
                        <h3>office</h3>
                        <p>
                            Address: <br/>
                            Jahi, FCT <br/> Abuja Nigeria
                        </p>
                        <p>
                            Support: <br/>
                            support@bubble-ai.tech
                        </p>
                    </div>
                    {/* <div className="items company">
                        <h3>company</h3>
                        <Link className='link' to='/about-us'>About us</Link>
                        <Link className='link' to='/affilliate'>Afilliate Program</Link>
                        <Link className='link' to='/careers'>Careers</Link>
                        <Link className='link' to='/press-partners'>Press & Partnership</Link>
                    </div> */}
                    <div className="items support">
                        <h3>support</h3>
                        <Link className='link' to='/support'>Help & FAQ</Link>
                        <Link className='link' to='/support'>Contact Us</Link>
                        <Link className='link' to='/privacy'>Refunds</Link>
                        <Link className='link' to='/support'>Customer Care</Link>
                    </div>
                </span>
            </div>

            <div className="bottomHalf">
                <div className="socials">
                    <div className="background">
                        <IconButtonStyled $bg='#6FCBD1' color='#18343b' $pad='0.4rem' fontSize='1.5rem'>
                            <a
                                className='icons'
                                href="https://www.linkedin.com/company/bubbleai"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaLinkedinIn/>
                            </a>

                        </IconButtonStyled>
                    </div>
                    <div className="background">
                        <IconButtonStyled $bg='#6FCBD1' color='#18343b' $pad='0.4rem' fontSize='1.5rem'>
                            <a
                                className='icons'
                                href="https://www.instagram.com/_bubble.ai"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram/>
                            </a>
                        </IconButtonStyled>
                    </div>
                    <div className="background">
                        <IconButtonStyled $bg='#6FCBD1' color='#18343b' $pad='0.4rem' fontSize='1.5rem'>
                            <a
                                className='icons'
                                href="https://www.tiktok.com/@_bubbleai"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaTiktok/>
                            </a>
                        </IconButtonStyled>
                    </div>
                    <div className="background">
                        <IconButtonStyled $bg='#6FCBD1' color='#18343b' $pad='0.4rem' fontSize='1.5rem'>
                            <a
                                className='icons'
                                href="https://www.facebook.com/people/Bubble-Ai/61560018116402/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFacebookF/>
                            </a>
                        </IconButtonStyled>
                    </div>
                    <div className="background">
                        <IconButtonStyled $bg='#6FCBD1' color='#18343b' $pad='0.4rem' fontSize='1.5rem'>
                            <a
                                className='icons'
                                href="https://x.com/_bubbleai?" 
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaXTwitter/>
                            </a>
                        </IconButtonStyled>
                    </div>

                </div>

            </div>

            <div className="copyright">
                <p>copyright @bubble-ai.tech {new Date().getFullYear()}</p>
                <span className="others">
                    <Link to='/privacy' className='copyLinks'>Terms of Service</Link>
                    <Link to='/privacy' className='copyLinks'>Cookie Policy</Link>
                    <Link to='/privacy' className='copyLinks'>Privacy Policy</Link>
                    <Link to='/privacy' className='copyLinks'>General Terms and Conditions</Link>
                </span>
            </div>
        </FooterContainerStyled>

    )
};

export default Footer;